import styled from 'styled-components'

export const TitleChart = styled.h2`
  font-size: 24px;
  font-weight: 500;
  margin-left: 15px;
  margin-top: 30px;
`

export const CardsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 16px;
  /* border: 1px solid black; */
`
